// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Lightbox_overlay__FWIEj","lightbox":"Lightbox_lightbox__hW0WN"};